import { DateTime } from "luxon";

export const normalizeDate = (date, timeZone) => {
    if (!date) {
        return DateTime.now().setZone(timeZone).startOf("day");
    }
    if (DateTime.isDateTime(date)) {
        return date.setZone(timeZone);
    }
    if (date instanceof Date) {
        return DateTime.fromJSDate(date).setZone(timeZone);
    }
    return DateTime.fromISO(String(date), { setZone: true }).setZone(timeZone);
};
